import React from 'react';
import { AlertCircle, Crown, X } from 'lucide-react';
import { useSubscription } from '../context/SubscriptionContext';

const TrialBanner = ({ onUpgrade, onDismiss }) => {
  const { subscriptionStatus, getTrialDaysLeft } = useSubscription();
  
  if (!subscriptionStatus || subscriptionStatus.status !== 'trial') {
    return null;
  }

  const daysLeft = getTrialDaysLeft();
  
  return (
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Crown className="h-5 w-5" />
          <div className="flex items-center space-x-2">
            <AlertCircle className="h-4 w-4" />
            <span className="font-medium">
              Essai gratuit : {daysLeft} jour{daysLeft > 1 ? 's' : ''} restant{daysLeft > 1 ? 's' : ''}
            </span>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <button
            onClick={onUpgrade}
            className="bg-white text-blue-600 px-4 py-1.5 rounded-lg font-semibold hover:bg-blue-50 transition-colors text-sm"
          >
            Passer à la version payante
          </button>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="text-white/80 hover:text-white transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;
